/* eslint-disable */
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
export default function Header(props){
  let navigate = useNavigate()
  let [isHover, setIsHover] = useState(false)
  let [isFullPage, setIsFullPage] = useState(false)
  let [mobMenuNum, setMobMenuNum] = useState(0)
  return(
    <>
    {/* header */}
    <div
      className={`headerWrap
        ${props.scrollUpDown == 'up' || props.scrollValue == 0 ? 'up' : 'down'}
        ${props.scrollValue != 0 || isHover || location.pathname == '/' ? 'white' : ''}
      `}
      onMouseLeave={() => {setIsHover(false)}}
    >
      {/* main menu */}
      <div
        className="headerInner"
        onMouseEnter={() => {setIsHover(true)}}
      >
        <button
          className="headerLogo"
          onClick={() => {
            navigate('/')
            setIsHover(false)
          }}
        >
          {
            props.scrollValue != 0 || isHover || location.pathname == '/' ?
            <img src="/img/logo_black.png" alt="logo"/> :
            <img src="/img/logo_white.png" alt="logo"/>
          }
        </button>
        <div className="headerBox">
          {
            props.menu.map((a, i) => (
              <button
                key={i}
                className="headerMenu"
                onClick={() => {navigate(a.sub[0].url)}}
                style={{color : location.pathname.includes(a.url) ? '#f0802b' : ''}}
              >
                {a.name}
              </button>
            ))
          }
          <div className="headerVar" style={{
            left :
            location.pathname.includes('intro') ?
            '0%' :
            location.pathname.includes('business') ?
            '25%' :
            location.pathname.includes('company') || location.pathname.includes('notice') ?
            '50%' :
            location.pathname.includes('human') || location.pathname.includes('employ') ?
            '75%' : '0%',
            opacity : location.pathname == '/' ? '0' : '1'
          }}></div>
        </div>
        <button
          className="headerBtn"
          onClick={() => {
            setIsFullPage(true)
            if(location.pathname.includes('intro')){
              setMobMenuNum(1)
            }else if(location.pathname.includes('business')){
              setMobMenuNum(2)
            }else if(location.pathname.includes('company')){
              setMobMenuNum(3)
            }else if(location.pathname.includes('human')){
              setMobMenuNum(4)
            }else{
              setMobMenuNum(0)
            }
          }}
        >
          <div className="headerBtnOne"></div>
          <div className="headerBtnOne"></div>
          <div className="headerBtnOne"></div>
        </button>
      </div>
      {/* sub menu */}
      <div className={`headerSubMenu ${isHover ? 'on' : ''}`}>
        <div className="headerSubInner">
          <div className="headerSubBox">
            {
              props.menu.map((a, i) => (
                <div key={i} className="headerSubOne">
                  {
                    a.sub.map((e, n) => (
                      <button
                        key={n}
                        className="headerSubBtn"
                        onClick={() => {
                          navigate(e.url)
                          setIsHover(false)
                        }}
                        style={location.pathname.includes(e.url) ? {color : '#f0802b', textDecoration : 'underline'} : {}}
                      >
                        {e.name}
                      </button>
                    ))
                  }
                </div>
              ))
            }
          </div>
        </div>
      </div>
    </div>
    {/* top btn */}
    <button
      className={`topBtn ${props.scrollValue != 0 ? 'on' : ''}`}
      onClick={() => {window.scrollTo({top : 0, behavior : 'smooth'})}}
    >
      <div className="topTriangle"></div>
    </button>
    {/* full page */}
    {
      isFullPage &&
      <div className={`fullPageWrap ${isFullPage ? 'on' : ''}`}>
        <div className="fullPageBack"></div>
        <button className="fullPageXbtn" onClick={() => {setIsFullPage(false)}}>
          <div></div>
          <div></div>
        </button>
        <div className="fullPageMenu">
          {
            props.menu.map((a, i) => (
              <div key={i} className="fullPageBox">
                <button
                  className="fullPageTitle"
                  style={{color : location.pathname.includes(a.url) ? '#f0802b' : ''}}
                  onClick={() => {
                    navigate(a.sub[0].url)
                    setIsFullPage(false)
                  }}
                >
                  {a.name}
                </button>
                <div className="fullPageSub">
                  {
                    a.sub.map((e, n) => (
                      <button
                        key={n}
                        className="fullPageBtn"
                        onClick={() => {
                          navigate(e.url)
                          setIsFullPage(false)
                        }}
                        style={location.pathname.includes(e.url) ? {color : '#f0802b', textDecoration : 'underline'} : {}}
                      >
                          {e.name}
                      </button>
                    ))
                  }
                </div>
              </div>
            ))
          }
        </div>
      </div>
    }
    {/* 모바일 */}
    {
      isFullPage &&
      <div className="mobMenuWrap">
        <button
          className="fullPageXbtn black"
          onClick={() => {
            setIsFullPage(false)
          }}
        >
          <div></div>
          <div></div>
        </button>
        <div className="mobMenuBox">
          {
            props.menu.map((a, i) => (
              <div className="mobMenuOne" key={i}>
                <button
                  className={`mobMenuToggle ${(i + 1) == mobMenuNum ? 'on' : ''}`}
                  onClick={() => {
                    if(mobMenuNum == (i + 1)){
                      setMobMenuNum(0)
                    }else{
                      setMobMenuNum(i + 1)
                    }
                  }}
                >
                  {a.name}
                  <div className={`mobMenuPluse ${(i + 1) == mobMenuNum ? 'on' : ''}`}></div>
                </button>
                <div
                  className={`mobMenuList ${(i + 1) == mobMenuNum ? '' : 'hide'}`}
                  style={{
                    height : a.sub.length == 4 ? '188px' :
                    a.sub.length == 3 ? '148px' :
                    a.sub.length == 2 ? '109px' :
                    a.sub.length == 1 ? '69px' : ''
                  }}
                >
                {
                  a.sub.map((e, n) => (
                    <button
                      key={n}
                      className={`mobMenuBtn ${location.pathname.includes(e.url) ? 'on' : ''}`}
                      onClick={() => {
                        navigate(e.url)
                        setIsFullPage(false)
                      }}
                    >
                      {e.name}
                    </button>
                  ))
                }
                </div>
              </div>
            ))
          }
        </div>
      </div>
    }
    </>
  )
}